//export const apiUrl = 'http://localhost:8000/';
export const apiUrl = 'https://baobab-beta.com/';

//export const apiWS = 'ws://' + apiUrl.split('//')[1];
export const apiWS = 'wss://' + apiUrl.split('//')[1];
